import { Component, HostListener, OnInit } from '@angular/core';
import { Video } from 'src/app/models/video.model';
import { UsersService } from 'src/app/services/users.service';
import { VideosService } from 'src/app/services/videos.service';

@Component({
  selector: 'home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})

export class HomePageComponent implements OnInit {


  videos: Video[] = []

  pageNum = 1

  loading: boolean

  finishedLoading: boolean

  showH2 = false

  showSearchCheckbox = false
  userId=0

  constructor(private videosService: VideosService, private usersService: UsersService) { }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: any) {
    if (window.innerHeight + window.scrollY + 800 >= document.body.offsetHeight) {
      if (!this.loading && !this.finishedLoading)
        this.getNewVideos()
    }
  }

  selectOption(selector: string) {
  }

  ngOnInit(): void {
    this.usersService.currentUser.subscribe(
      u => this.userId = u.userId
    )
    this.getNewVideos()
  }

  loadAgain() {
    this.pageNum = 1
    this.videos = []
    this.getNewVideos()
  }

  serShowH2() {
    this.showH2 = !this.showH2
  }

  serShowSearchCheckbox() {
    this.showSearchCheckbox = !this.showSearchCheckbox
  }

  getNewVideos() {
    this.loading = true
    this.videosService.getNew(this.pageNum).subscribe(v => {
      if (v.length === 0)
        this.finishedLoading = true
      this.pageNum++
      console.log('last videos', v)
      this.videos.push(...v)
      this.loading = false
    }, err => console.log('error', err))
  }

}
